import { ScrollText } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

// The releases page is a generated docs page (see `src/docs-contribution.ts`),
// so this plugin contributes no route component - only the icon used by the
// account-menu "Releases" nav item / command.
export default createWebRegistration({
  icons: { ScrollText },
});
